import * as types from "../../Types/common";
import {
  SAVE_MEDICAL_AND_LIFESTYLE_V2,
  SET_MEDICAL_AND_LIFESTYLE_V2
} from "../../Types/medical&LifestyleV2";

export const setMedicalAndLifeStyle = (payload: any) => ({
  type: types.SET_MEDICAL_AND_LIFESTYLE,
  payload
});
export const saveMedicalDetailsAction = (apiData: any, leadId: any) => ({
  type: types.SAVE_MEDICAL_AND_LIFESTYLE,
  payload: { apiData, leadId }
});

export const setMedicalV2DetailsAction = (payload: Record<string, any>) => ({
  type: SET_MEDICAL_AND_LIFESTYLE_V2,
  payload
});

export const saveMedicalV2DetailsAction = (apiData: any, leadId: any) => ({
  type: SAVE_MEDICAL_AND_LIFESTYLE_V2,
  payload: { apiData, leadId }
});
